var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvLayoutTopBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 118,
    viewBox: "0 0 109 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2118_112220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 109,
    height: 118
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.738281 0H108.146V117.954H0.738281V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2118_112220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2118_112220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -72,
    width: 196,
    height: 190
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3475 -71.3574L196.117 14.1072L108.015 117.263L1.25195 31.804L89.3475 -71.3574Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2118_112220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2118_112220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -72,
    width: 107,
    height: 190
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.971 117.232L1.25195 31.8039L89.3475 -71.3574L107.971 117.232Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2118_112220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3475 -71.3574L196.117 14.1072L108.015 117.263L1.25195 31.804L89.3475 -71.3574Z",
    fill: "#0000E1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvLayoutTopBold);
export default __webpack_public_path__ + "static/media/adv-layout-top-bold.c7026af86cb0b5226f22828839429cfc.svg";
export { ForwardRef as ReactComponent };